import { DoneSharp } from '@mui/icons-material';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormLabel,
    Grid,
    IconButton,
    TextField
} from '@mui/material';
import { selectCurrentToken } from 'features/auth/authSlice';
import { useEffect } from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { successAlert } from 'ui-component/Toasts';
import { axiosInstance } from 'utils/axios';
import { formatDate } from 'utils/index';

const RemarkPopup = ({ customerID, dateLabel }) => {
    const token = useSelector(selectCurrentToken);

    const [open, setOpen] = useState(false);

    const [customerFollowUp, setCustomerFollowUp] = useState();
    const [loading, setLoading] = useState(false);

    const [followUpOne, setFollowUpOne] = useState();
    const [followUpTwo, setFollowUpTwo] = useState();
    const [followUpThree, setFollowUpThree] = useState();
    const [followUpFour, setFollowUpFour] = useState();
    const [followUpFive, setFollowUpFive] = useState();

    const [remarkOne, setRemarkOne] = useState('');
    const [remarkTwo, setRemarkTwo] = useState('');
    const [remarkThree, setRemarkThree] = useState('');
    const [remarkFour, setRemarkFour] = useState('');
    const [remarkFive, setRemarkFive] = useState('');

    const [followUpDateOne, setFollowUpDateOne] = useState('');
    const [followUpDateTwo, setFollowUpDateTwo] = useState('');
    const [followUpDateThree, setFollowUpDateThree] = useState('');
    const [followUpDateFour, setFollowUpDateFour] = useState('');
    const [followUpDateFive, setFollowUpDateFive] = useState('');

    const fetchCustomerFollowUp = async () => {
        setLoading(true);
        try {
            const res = await axiosInstance.get(
                `/Report/Customer/FollowUp?customerID=${customerID}&dateLabel=${dateLabel.format('YYYY-MM-DD')}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (res.status === 200) {
                setCustomerFollowUp(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (open) {
            fetchCustomerFollowUp();
        }
    }, [open]);

    useEffect(() => {
        if (customerFollowUp) {
            customerFollowUp.map((cfu) => {
                if (cfu.followUpNumber === 1) {
                    setFollowUpOne(cfu);
                    setRemarkOne(cfu.remark);
                    setFollowUpDateOne(cfu.createdDate);
                }

                if (cfu.followUpNumber === 2)
                {
                    setFollowUpTwo(cfu);
                    setRemarkTwo(cfu.remark);
                    setFollowUpDateTwo(cfu.createdDate);
                }

                if (cfu.followUpNumber === 3)
                {
                    setFollowUpThree(cfu);
                    setRemarkThree(cfu.remark);
                    setFollowUpDateThree(cfu.createdDate);
                }

                if (cfu.followUpNumber === 4)
                {
                    setFollowUpFour(cfu);
                    setRemarkFour(cfu.remark);
                    setFollowUpDateFour(cfu.createdDate);
                }

                if (cfu.followUpNumber === 5)
                {
                    setFollowUpFive(cfu);
                    setRemarkFive(cfu.remark);
                    setFollowUpDateFive(cfu.createdDate);
                }   
            });
        }
    }, [customerFollowUp]);

    const handleUpdate = async (followUpNumber, newRemark) => {
        setLoading(true);

        const updateData = {
            dateLabel,
            customerID,
            followUpNumber,
            remark: newRemark
        };
        try {
            const res = await axiosInstance.put(`/Report/FollowUp/Customer`, updateData, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                successAlert('Remarks updated success.');
                setOpen(false);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Button variant="contained" onClick={() => setOpen(true)}>
                Remark
            </Button>
            <Dialog fullWidth maxWidth={'md'} open={open} onClose={() => setOpen(false)}>
                <DialogTitle>Remarks</DialogTitle>
                <DialogContent>
                    <Box
                        sx={{
                            display: 'flex',
                            gap: '10px',
                            paddingY: '10px',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <FormLabel>Follow Up Date - {followUpOne?.createdDate ? formatDate(followUpOne?.createdDate) : '-'}</FormLabel>
                        <TextField label="Remark 1" variant="outlined" value={remarkOne} onChange={(e) => setRemarkOne(e.target.value)} />
                        <IconButton onClick={() => handleUpdate(1, remarkOne)} disabled={loading}>
                            <DoneSharp />
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            gap: '10px',
                            paddingY: '10px',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <FormLabel>Follow Up Date - {followUpTwo?.createdDate ? formatDate(followUpTwo?.createdDate) : '-'}</FormLabel>
                        <TextField label="Remark 2" variant="outlined" value={remarkTwo} onChange={(e) => setRemarkTwo(e.target.value)} />
                        <IconButton onClick={() => handleUpdate(2, remarkTwo)} disabled={loading}>
                            <DoneSharp />
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            gap: '10px',
                            paddingY: '10px',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <FormLabel>Follow Up Date - {followUpThree?.createdDate ? formatDate(followUpThree?.createdDate) : '-'}</FormLabel>
                        <TextField label="Remark 3" variant="outlined" value={remarkThree} onChange={(e) => setRemarkThree(e.target.value)} />
                        <IconButton onClick={() => handleUpdate(3, remarkThree)} disabled={loading}>
                            <DoneSharp />
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            gap: '10px',
                            paddingY: '10px',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <FormLabel>Follow Up Date - {followUpFour?.createdDate ? formatDate(followUpFour?.createdDate) : '-'}</FormLabel>
                        <TextField label="Remark 4" variant="outlined" value={remarkFour} onChange={(e) => setRemarkFour(e.target.value)} />
                        <IconButton onClick={() => handleUpdate(4, remarkFour)} disabled={loading}>
                            <DoneSharp />
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            gap: '10px',
                            paddingY: '10px',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <FormLabel>Follow Up Date - {followUpFive?.createdDate ? formatDate(followUpFive?.createdDate) : '-'}</FormLabel>
                                    <TextField label="Remark 5" variant="outlined" value={remarkFive} onChange={(e) => setRemarkFive(e.target.value)} />
                        <IconButton onClick={() => handleUpdate(5, remarkFive)} disabled={loading}>
                            <DoneSharp />
                        </IconButton>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)} disabled={loading}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default RemarkPopup;
